<template>
<div>
    <!-- loader spinner -->
    <div v-if="isLoading" class="overlayLoading">
        <div class="spanner">
            <div class="loader"></div>
            <div>
                <b style="font-family: 'Gotham Pro';">Poza se încarcă... <br />Te rugăm să aștepți generarea ei.</b>
            </div>
        </div>
    </div>

    <!-- sectiune alege decada -->
    <div v-if="step == 1">
        <header class="hero">
            <div class="brand">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
            <div class="txt-1">
                <img src="/img/txt-vezi-cum-ai-fi-aratat-in-trecut.png" alt="Vezi cum ai fi aratat in trecut" class="" />
            </div>
            <div class="txt-2 mt-1" style="width: 100%; max-width: 100%;">
                <!-- <img src="/img/txt-alege-o-perioada.png" alt="Alege o perioada" class="" /> -->
                <p>Alege decada preferată și descoperă filtrele disponibile</p>
            </div>
        </header>
        <section class="eras" style="position: relative;">
            <div class="era">
                <div class="era-content">
                    <img @click="goToStep(2)" src="/img/anii-1900.jpg" alt="Stil 1900" class="Anii 1900" />
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <img @click="goToStep(3)" src="/img/anii-1970.jpg" alt="Stil 1970" class="Anii 1970" />
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <img @click="goToStep(4)" src="/img/anii-2000.jpg" alt="Stil 2000" class="Anii 2000" />
                </div>
            </div>
        </section>

        <footer style="background: transparent;">
            <p>
                Campanie desfășurată în perioada 20 august – 20 septembrie 2025. Consultă gratuit regulamentul 
                <a href="/pdf/Regulament_Ursus_Filtre_Legendare.pdf" target="_blank" style="text-transform: none;">Campaniei Ursus “Ursus Filtre Legendare”</a>
            </p>
        </footer>
    </div>

    <!-- Aici sunt filtrele pentru 1900!!!! -->
    <div v-else-if="step == 2">
        <header class="hero">
            <div class="brand">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
            <div class="txt-1">
                <img src="/img/txt-vezi-cum-ai-fi-aratat-in-trecut.png" alt="Vezi cum ai fi aratat in trecut" class="" />
            </div>
            <div class="txt-2 mt-1" style="width: 100%; max-width: 100%;">
                <!-- <img src="/img/txt-alege-filtru.png" alt="Alege filtru" class="" /> -->
                <p>Alege un filtru</p>
            </div>
        </header>
        <section class="eras" style="position: relative;">
            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1900/V1B.png')"><img src="/img/1900/V1B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1900/V2B.png')"><img src="/img/1900/V2B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1900/V1F.png')"><img src="/img/1900/V1F.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1900/V2F.png')"><img src="/img/1900/V2F.png" alt="" /></div>
                </div>
            </div>
        </section>
        <div class="text-center pb-3">
            <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Înapoi la alege decada</button>
        </div>
    </div>
    <!-- Aici sunt filtrele pentru 1900!!!! -->

    <!-- Aici sunt filtrele pentru 1970!!!! -->
    <div v-else-if="step == 3">
        <header class="hero">
            <div class="brand">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
            <div class="txt-1">
                <img src="/img/txt-vezi-cum-ai-fi-aratat-in-trecut.png" alt="Vezi cum ai fi aratat in trecut" class="" />
            </div>
            <div class="txt-2 mt-1" style="width: 100%; max-width: 100%;">
                <!-- <img src="/img/txt-alege-filtru.png" alt="Alege filtru" class="" /> -->
                <p>Alege un filtru</p>
            </div>
        </header>
        <section class="eras" style="position: relative;">
            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1970/V1B.png')"><img src="/img/1970/V1B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1970/V2B.png')"><img src="/img/1970/V2B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1970/V1F.png')"><img src="/img/1970/V1F.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('1970/V2F.png')"><img src="/img/1970/V2F.png" alt="" /></div>
                </div>
            </div>
        </section>
        <div class="text-center">
            <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Înapoi la alege decada</button>
        </div>
    </div>
    <!-- Aici sunt filtrele pentru 1970!!!! -->

    <!-- Aici sunt filtrele pentru 2000!!!! -->
    <div v-else-if="step == 4">
        <header class="hero">
            <div class="brand">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
            <div class="txt-1">
                <img src="/img/txt-vezi-cum-ai-fi-aratat-in-trecut.png" alt="Vezi cum ai fi aratat in trecut" class="" />
            </div>
            <div class="txt-2 mt-1" style="width: 100%; max-width: 100%;">
                <!-- <img src="/img/txt-alege-filtru.png" alt="Alege filtru" class="" /> -->
                <p>Alege un filtru</p>
            </div>
        </header>
        <section class="eras" style="position: relative;">
            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('2000/V1B.png')"><img src="/img/2000/V1B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('2000/V2B.png')"><img src="/img/2000/V2B.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('2000/V1F.png')"><img src="/img/2000/V1F.png" alt="" /></div>
                </div>
            </div>

            <div class="era">
                <div class="era-content">
                    <div @click="chosedFilter('2000/V2F.png')"><img src="/img/2000/V2F.png" alt="" /></div>
                </div>
            </div>
        </section>
        <div class="text-center">
            <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Înapoi la alege decada</button>
        </div>
    </div>
    <!-- Aici sunt filtrele pentru 2000!!!! -->

    <div v-else-if="step == 5">
        <header class="hero">
            <div class="brand">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
        </header>

        <section class="eras" style="position: relative;">
            <!-- Afisezi div-urile in functie de anul ales -->
            <div v-if="filter.match(/1900/)" class="grafica-1900">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/grafica-1900.png" alt="Grafica 1900">
                </div>
            </div>
            <div v-if="filter.match(/1970/)" class="grafica-1970">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/grafica-1970.png" alt="Grafica 1970">
                </div>
            </div>
            <div v-if="filter.match(/2000/)" class="grafica-2000">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/grafica-2000.png" alt="Grafica 2000">
                </div>
            </div>
            <!-- end Afisezi div-urile in functie de anul ales -->

            <!-- Se afiseaza la toate -->
            <div  class="bear">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/bear.png" alt="Bear">
                </div>
            </div>
            <!-- end Se afiseaza la toate -->


            <!-- Secțiunea upload photo -->
            <div class="center-section" style="width: 100%; margin: 0 auto; position: relative; z-index: 1;">
                <div class="upload-area">
                    <div class="upload-box" style="max-width: 368px; margin-left: auto; margin-right: auto">
                        <div class="upload-inner">
                            <!-- preview imagine -->
                            <img
                                :src="image_url"
                                :class="{
                                    'd-none': $v.image.$error,
                                    'd-block w-100 pt-2 pb-2': image_url
                                }"
                                id="preview"
                                alt=""
                            />
                            <!-- icon camera -->
                            <div v-if="!image_url">
                                <img @click="triggerFileDialog" id="camera-icon" src="/img/camera-icon.png" alt="Upload Icon" style="cursor: pointer;">
                            </div>
                        </div>
                    </div>
                    <div class="form-group" style="max-width: 368px; margin-left: auto; margin-right: auto">
                        <!-- actual upload which is hidden -->
                        <input
                            style="display: none;"
                            ref="fileInput"
                            type="file"
                            name="photo"
                            id="photo"
                            autocomplete="off"
                            accept="image/png, image/jpeg, image/webp"
                            @change="onImageChange($event)"
                            />

                        <!-- our custom upload button -->
                        <label for="photo" id="incarca-poza">
                            <img src="/img/incarca-poza.jpg" alt="Incarca Poza" class="">
                        </label>

                        <div :class="{'is-invalid': $v.image.$error, 'is-valid': !$v.image.$invalid}"></div>
                        <div class="invalid-feedback">
                            <div class="error" v-if="!$v.image.isTrueImage">Invalid image file.</div>
                        </div>

                        <!-- name of file chosen -->
                        <span id="file-chosen">Nicio poză încărcată</span>
                    </div>

                    <div style="max-width: 640px; margin-left: auto; margin-right: auto">
                        <label class="checkbox" for="acord_regulament">
                            <span class="checkbox__input">
                            <input
                                type="checkbox"
                                name="acord_regulament"
                                id="acord_regulament"
                                @change="$v.termeni.$touch()"
                                v-model.trim="$v.termeni.$model"
                                autocomplete="off">
                            <span class="checkbox__control">
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true" focusable="false">
                                <path fill='none' stroke='currentColor' stroke-width='3' d='M1.73 12.91l6.37 6.37L22.79 4.59' /></svg>
                            </span>
                            </span>
                            <span class="radio__label">Declar că am peste 18 ani, am citit și sunt de acord cu prelucrarea datelor cu caracter personal transmise inclusiv prin intermediul inteligenței artificiale(OpenAI).<br /> Politica de prelucare a datelor personale este disponibilă <a href="/pdf/Regulament_Ursus_Filtre_Legendare.pdf" target="_blank">aici</a>.</span>
                        </label>
                        <div :class="{'is-invalid': $v.termeni.$error, 'is-valid': !$v.termeni.$invalid}"></div>
                            <div class="invalid-feedback">
                                <span v-if="!$v.termeni.sameAs" >Câmpul sunt de acord cu prelucrarea datelor cu caracter personal este obligatoriu!</span>
                                <div class="error" v-if="!$v.image.isTrueImage">Poza este obligatorie.</div>
                            </div>
                    </div>

                    <div class="text-center" style="max-width: 368px; margin-left: auto; margin-right: auto">
                        <button class="submitBtn submitBtn-fin mt-3" @click="saveForm">Trimite</button>
                    </div>
                    <div class="text-center" style="max-width: 368px; margin-left: auto; margin-right: auto">
                        <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Încearcă din nou!</button>
                    </div>

                </div>
            </div>
        </section>
    </div>
    <div v-else-if="step == 6">
        <header class="hero"></header>

        <section class="eras" style="position: relative;">
            <!-- Se afiseaza la toate -->
            <div  class="ursus-logo-fin">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/ursus-logo-fin.png" alt="Ursus">
                </div>
            </div>
            <div  class="bear bear-mob">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/bear.png" alt="Bear">
                </div>
            </div>
            <!-- end Se afiseaza la toate -->

            <!-- Secțiunea upload photo -->
            <div class="center-section" style="width: 100%; max-width: 368px; margin: 0 auto; position: relative; z-index: 1;">
                <div class="upload-area">
                    <div class="upload-box" style="position: relative; padding: 10px 0 0 0; background: #c5122f;">
                        <div class="upload-inner" style="border: 0px dotted #fff;">
                            <!-- preview imagine -->
                            <img
                                :src="generated_image_url"
                                :class="{
                                    'd-block w-100 pt-2 pb-2': generated_image_url
                                }"
                                id="preview"
                                alt=""
                            />
                        </div>
                    </div>

                    <!-- Afisezi div-urile in functie de anul ales -->
                    <div v-if="filter.match(/1900/)" class="fin-img-1900">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-1900.png" alt="1900">
                        </div>
                    </div>
                    <div v-if="filter.match(/1970/)" class="fin-img-1970">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-1970.png" alt="1970">
                        </div>
                    </div>
                    <div v-if="filter.match(/2000/)" class="fin-img-2000">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-2000.png" alt="2000">
                        </div>
                    </div>
                    <!-- end Afisezi div-urile in functie de anul ales -->

                    <div class="mt-2 mb-2">
                        <img src="/img/txt-vrei-sa-pastrezi-amintirea.png" alt="Vrei sa pastrezi amintirea?">
                    </div>

                    <div class="form-group" style="position: relative;">
                        <div style="position: absolute; top: 0; left: 0; ">
                            <label for="email" style="color: #e3000a; height: calc(1.6em + 0.75rem + 2px); padding: 0.375rem 0rem 0.375rem 0.75rem; font-size: 0.9rem; font-weight: 700; line-height: 1.6;">EMAIL:</label>
                        </div>
                        <input 
                            type="email" 
                            class="form-control"
                            @change="$v.email.$touch()"
                            v-model.trim="$v.email.$model"
                            :class="{
                                'is-invalid': $v.email.$error || serverErrors.email,
                                'is-valid': !$v.email.$invalid && !serverErrors.email
                            }"
                            name="email"
                            id="email"
                            placeholder="Email"
                            autocomplete="off"
                            style="padding-left: 4.375rem; color: #000;">

                            <div class="invalid-feedback">
                                <span v-if="!$v.email.required">Campul este obligatoriu!</span>
                                <span v-if="serverErrors.email">{{serverErrors.email[0]}}</span>
                            </div>
                    </div>

                    <div class="text-center">
                        <button class="submitBtn submitBtn-fin mt-3" @click="downloadImage">Descarcă poza</button>
                    </div>
                    <div class="text-center">
                        <button class="submitBtn submitBtn-fin mt-3" @click="sendEmail">Trimite pe email</button>
                    </div>
                    <div class="text-center pb-4">
                        <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Încearcă din nou!</button>
                    </div>

                </div>
            </div>
        </section>
    </div>
    <div v-else-if="step == 7">
        <header class="hero">
            <div class="brand viewH">
                <a href="/"><img src="/img/logo.png" alt="Ursus Logo" class="ursus-logo"></a>
            </div>
            <div class="txt-2 mt-1" style="width: 100%; max-width: 100%;">
                <h4>{{ final_message }}</h4>
            </div>
        </header>

        <section class="eras" style="position: relative;">
            <!-- Se afiseaza la toate -->
            <div  class="ursus-logo-fin">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/ursus-logo-fin.png" alt="Ursus">
                </div>
            </div>
            <div  class="bear bear-mob">
                <div style="position: relative; width: 100%; height: auto">
                    <img src="/img/bear.png" alt="Bear">
                </div>
            </div>
            <!-- end Se afiseaza la toate -->

            <!-- Secțiunea upload photo -->
            <div class="center-section" style="width: 100%; max-width: 368px; margin: 0 auto; position: relative; z-index: 1;">
                <div class="upload-area">
                    <div class="upload-box" style="position: relative; padding: 10px 0 0 0; background: #c5122f;">
                        <div class="upload-inner" style="border: 0px dotted #fff;">
                            <!-- preview imagine -->
                            <img
                                :src="generated_image_url"
                                :class="{
                                    'd-block w-100 pt-2 pb-2': generated_image_url
                                }"
                                id="preview"
                                alt=""
                            />
                        </div>
                    </div>
                    <!-- Afisezi div-urile in functie de anul ales -->
                    <div v-if="filter.match(/1900/)" class="fin-img-1900">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-1900.png" alt="1900">
                        </div>
                    </div>
                    <div v-if="filter.match(/1970/)" class="fin-img-1970">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-1970.png" alt="1970">
                        </div>
                    </div>
                    <div v-if="filter.match(/2000/)" class="fin-img-2000">
                        <div style="position: relative; width: 100%; height: auto">
                            <img src="/img/fin-img-2000.png" alt="2000">
                        </div>
                    </div>
                    <!-- end Afisezi div-urile in functie de anul ales -->

                    <div class="text-center">
                        <button class="submitBtn submitBtn-fin mt-3" @click="finalStep">Încearcă din nou!</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>

</template>

<script>

import {required, email, sameAs} from "vuelidate/lib/validators";
const touchMap = new WeakMap();

export default {
  mounted() {
    // console.log("ExampleComponent mounted!");
  },
  data() {
		return {
            isLoading: false,
            generated_image_url: '',
            termeni: false,
            step: 1,
            image: null,
            image_url: '',
            image_name: '',
            email: '',
            filter: '',
            db_id: null,
            final_message: '',
            serverErrors: {},
		};
	},
    methods: {
        triggerFileDialog() {
            this.$refs.fileInput.click()
        },
        delayTouch($v) {
            $v.$reset();
            this.serverErrors = {};
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v));
            }
            touchMap.set($v, setTimeout($v.$touch, 1000));
        },
        onImageChange(e) {
			const files =  e.target.files || e.dataTransfer.files;
			const file = files[0];
			this.image = file;
			this.image_name = e.target.files[0].name;
			this.$v.image.$touch();
			if (this.$v.image.$error) return;	
			this.image_url = URL.createObjectURL(file);
		},
        saveForm() {
            this.$v.image.$touch();
            this.$v.termeni.$touch();
            if (!this.$v.image.$invalid && !this.$v.termeni.$invalid) {

                // loading
                this.isLoading = true;
                document.body.classList.add('noClick');

                let formData = new FormData();
                formData.append("filter", this.filter);
                formData.append("image", this.image);

                let config = { 
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                axios
                    .post("/legendar/api", formData, config)
                    .then((response) => {
                        if (response.data.result) {
                            this.generated_image_url = response.data.result;
                            this.db_id = response.data.db_id;
                            this.serverErrors = {};
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.serverErrors = error.response.data.errors;
                        }
                    })
                    .finally(() => {
                        // end loading
                        this.isLoading = false;
                        document.body.classList.remove('noClick');
                        this.goToStep(6);
                    });
            }
        },
        sendEmail() {
            this.$v.$touch();
            if (!this.$v.email.$invalid) {

                // loading
                this.isLoading = true;
                document.body.classList.add('noClick');

                let formData = new FormData();
                formData.append("email", this.email);
                formData.append("generated_image_url", this.generated_image_url);
                formData.append("db_id", this.db_id);

                let config = { 
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                axios
                    .post("/send-mail", formData, config)
                    .then((response) => {
                        if (response.data.status) {
                            this.final_message = 'Mulțumim pentru participare!';
                            if (response.data.status == 5) this.final_message = 'Ai depasit limita de email-uri trimise!';
                            this.goToStep(7);
                            this.serverErrors = {};
                        }
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.serverErrors = error.response.data.errors;
                        }
                    })
                    .finally(() => {
                        // end loading
                        this.isLoading = false;
                        document.body.classList.remove('noClick');
                        this.goToStep(7);
                    });
            }
        },
        async downloadImage() {
            try {
                const response = await fetch(this.generated_image_url, { mode: "cors" });
                if (!response.ok) throw new Error("Network response was not ok");

                const blob = await response.blob();

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "ursus.jpeg"; // you can set a custom filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(link.href); // cleanup memory
            } catch (err) {
                console.error("Download failed:", err);
            }
        },
        finalStep() {
            this.goToStep(1);
            this.generated_image_url = '';
            this.termeni = false;
            this.image = null;
            this.image_url = '';
            this.image_name = '';
            this.email = '';
            this.filter = '';
        },
        chosedFilter(filter) {
            this.filter = filter;
            this.step = 5;
        },
        goToStep(step) {
            this.step = step;
        },

    },

    validations: {
        termeni: {
			sameAs: sameAs(() => true),
		},
        image: {
            valid: function(value) {
                if (!value) {
                    return true;
                }
                let file = value;
                return file.type.startsWith('image');
            }
        },
        email: {
            required,
            email,
        },
	}
}
</script>